module.exports = __webpack_public_path__ + "img/empty-chart.5fb5ef6d.png";